import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { usePlayer } from "@/lib/player";

const LINKS = [["/aktualnosci", "Aktualności"], ["/pobierz", "Pobierz"], ["/ranking", "Ranking"], ["/rejestracja", "Rejestracja"]];

export default function SiteNav({ name }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { player, logout, openLogin } = usePlayer();
  const logged = !!player;
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  const link = ({ isActive }) =>
    `text-xs tracking-[0.25em] transition-colors ${isActive ? "text-amber-300 border-b border-amber-400 pb-1" : "text-slate-400 hover:text-amber-300"}`;

  return (
    <nav className={`fixed top-0 inset-x-0 z-40 transition-[background-color,border-color] duration-300 border-b ${scrolled || open ? "bg-[#05060f]/92 backdrop-blur-xl border-slate-500/25" : "bg-gradient-to-b from-[#05060f]/80 to-transparent border-transparent"}`} data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 font-display text-base md:text-lg tracking-[0.12em] text-slate-100 leading-tight" data-testid="site-logo-link">
          <img src="/assets/koselig-icon.png" alt="" className="w-9 h-9" />
          {name}
        </Link>
        <div className="hidden md:flex items-center gap-10">
          {LINKS.map(([h, l]) => (
            <NavLink key={h} to={h} className={link} data-testid={`site-nav-${h.slice(1)}`}>{l}</NavLink>
          ))}
          {logged && <NavLink to="/panel" className={link} data-testid="site-nav-panel">Panel gracza</NavLink>}
          {logged
            ? <button onClick={logout} className="btn !min-h-[38px] !py-0 !px-5 !text-[11px] !tracking-[0.12em]" data-testid="site-nav-logout">Wyloguj</button>
            : <button onClick={openLogin} className="btn btn-primary !min-h-[38px] !py-0 !px-5 !text-[11px] !tracking-[0.12em]" data-testid="site-nav-login">Zaloguj</button>}
        </div>
        <button className="md:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="site-nav-toggle">{open ? <X /> : <Menu />}</button>
      </div>
      {open && (
        <div className="md:hidden px-6 pb-6 flex flex-col gap-4" data-testid="site-nav-mobile">
          {LINKS.map(([h, l]) => <NavLink key={h} to={h} className={({ isActive }) => `text-sm tracking-[0.2em] ${isActive ? "text-amber-300" : "text-slate-300"}`}>{l}</NavLink>)}
          {logged && <NavLink to="/panel" className={({ isActive }) => `text-sm tracking-[0.2em] ${isActive ? "text-amber-300" : "text-slate-300"}`}>Panel gracza</NavLink>}
          {logged
            ? <button onClick={logout} className="btn w-full" data-testid="site-nav-logout-m">Wyloguj</button>
            : <button onClick={() => { setOpen(false); openLogin(); }} className="btn btn-primary w-full" data-testid="site-nav-login-m">Zaloguj</button>}
        </div>
      )}
    </nav>
  );
}
